import gql from 'graphql-tag';

export const updateCommercialContact = gql`
  mutation updateCommercialContact($id: ID!, $input: CommercialContactInput!) {
    updateCommercialContact(id: $id, input: $input) {
      id
      firstName
      lastName
      companyId
      jobRoleId
      deskPhone
      mobilePhone
      emailAddress
      ice
      createdAt
      createdBy
      updatedAt
      updater
      version
      Company {
        id
        name
        abbreviation
        version
      }
      JobRole {
        id
        name
      }
    }
  }
`;
